import { IsArray, IsDefined, IsInt, IsNumber, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

export class GetInputClosingStockDto {
  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  stockLocationIdList: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryIdList?: number[];

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  supplierId?: number;

  @IsOptional()
  search?: string;
}
